import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { icons } from 'lucide-angular';

@Component({
  selector: 'app-lucide-icon',
  templateUrl: './lucide-icon.component.html',
  styleUrls: ['./lucide-icon.component.scss'],
})
export class LucideIconComponent implements OnChanges {
  @Input() iconName = '';
  @Input() size = 24; 
  @Input() color = 'primary'; 

  resolvedColor = 'currentColor'; 
  iconObject: any | null = null;

  private colorMap: Record<string, string> = {
    primary: '#f78222',
    secondary: '#598d4e',
    tertiary: '#476b91',
    danger: '#ff002f',
    warning: '#f89406',
    success: '#2e8f56',
    white: '#ffffff',
    darkGray: '#333333',
    lightGray: '#666666',
    disabled: '#aaaaaa',
    green: '#004d1e'
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iconName'] || changes['color'] || changes['size']) {
      this.resolvedColor = this.resolveColor(this.color); 
      this.loadIcon();
    }
  }

  private loadIcon(): void {
    const formattedIconName = this.formatIconName(this.iconName);

    if (formattedIconName && icons[formattedIconName]) {
      this.iconObject = icons[formattedIconName]; 
    } else {
      console.error(`LucideIconComponent: Icon "${this.iconName}" not found as "${formattedIconName}".`);
      this.iconObject = null;
    }
  }

  private resolveColor(color: string): string {
    return this.colorMap[color] || color || 'currentColor'; 
  }

  private formatIconName(name: string): string {
    if (!name) {
      console.error('LucideIconComponent: Icon name is undefined or empty.');
      return '';
    }
  
    return name
      .split('-')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join('');
  }
}
